import React from "react";
import { ScreenSizeMetaForm, FormSchemaType } from "./ScreenSizeMetaForm";

export type ScreenSizeQuickCreateFormType = FormSchemaType;

interface Props {
  onSubmit: (values: ScreenSizeQuickCreateFormType) => void;
  isLoading: boolean;
  onCancel: () => void;
}

export const ScreenSizeQuickCreateForm: React.FC<Props> = ({ onSubmit, isLoading, onCancel }) => {
  return <ScreenSizeMetaForm onSubmit={onSubmit} isLoading={isLoading} onCancel={onCancel} showAsDialog={true} />;
};
